<template>
  <master-layout pageTitle="Segments">
    <div v-if="!editMode">
      <!-- desktop -->
      <div>
        <!-- Search Bar -->
        <div v-if="allSegments.length > 0 || isSearchSegment" class="segment-search-container">
          <SearchBar
            v-model="segmentFilter"
            placeholder="Search segments"
            :rightIcon="true"
            @search="searchSegments"
            @blur="onBlurSearch"
            class="segment-search-field"
          />

          <div class="desktop-only">
            <VButton class="vvd-btn-primary" connotation="cta" appearance="filled" label="Create New Segment" @click="() => editMode = true"></VButton>
          </div>
          <div class="mobile-only">
            <ActionPopOver :style="{'--width': '185px'}">
              <div class="listContainer">
                <button class="popover-item" @click="onClickCreateSagment">Create New Segment</button>
              </div>
            </ActionPopOver>
          </div>
        </div>

        <div v-if="allSegments.length > 0" class="gridMargin segmentContainer">
          <div class="segment-list">
            <div class="segment-table-header">
              <div class="col-name"><span class="vtext-subtitle">Name</span></div>
              <div class="col-actions desktop-only text-right"><span class="vtext-subtitle">Actions</span></div>
            </div>
          </div>

          <div class="segment-info">
            <div v-for="(segment, sIndex) in allSegments" :key="sIndex" class="segment-table-row rowBorder">
              <div class="col-name">
                <span class="vtext-body">{{ segment.name }}</span>
              </div>
              <div class="col-actions desktop-only">
                <div class="actionFlexContainer">
                  <span class="tooltip_container">
                    <VIcon name="download-line" :size="-5" class="primaryBlack cursorPointer" @click="downloadSegmentCustomers_Csv(segment.id)" />
                    <span class="tooltip_text" style="width: 150px">Download Segment Customers</span>
                  </span>
                  <span class="tooltip_container">
                    <VIcon name="edit-line" :size="-5" class="cursorPointer" @click="() => { editMode = true; segmentIndexToEdit = sIndex;}" />
                    <span class="tooltip_text">Edit segments</span>
                  </span>
                  <span class="tooltip_container">
                    <VIcon name="delete-line" :size="-5" connotation="alert" class="trashIcon cursorPointer" @click="() => { segmentToDeleteId = segment.id; deleteSegmentMode = true; }" />
                    <span class="tooltip_text">Delete segments</span>
                  </span>
                </div>
              </div>
              <div class="col-mobile-actions mobile-only">
                <ActionPopOver :style="{'--width': '215px'}">
                  <div class="listContainer">
                    <button class="popover-item" @click="downloadSegmentCustomers_Csv(segment.id)">Download Segment Customers</button>
                    <button class="popover-item" @click="() => { editMode = true; segmentIndexToEdit = sIndex;}">Edit segments</button>
                    <button class="popover-item popover-item--danger" @click="() => { segmentToDeleteId = segment.id; deleteSegmentMode = true; }">Delete segments</button>
                  </div>
                </ActionPopOver>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center" v-if="segmentFilter && segmentFilter.length && allSegments.length === 0">
          <img src="../../resources/images/not-found.svg" alt="not-found" class="filterImg"/>
          <h5> No segments matching this filter! 😟 <a @click="() => {segmentFilter = undefined; fetchSegments();}">Clear filter</a> </h5>
        </div>
        <div class="gridMargin text-center emptySegments" v-if="allSegments.length == 0 && !isSearchSegment">
          <div>
            <img src="./../../resources/images/segment-Pipeline.svg" alt="segments" class="segmentImg"/>
            <h2 class="segmentTitle ion-no-margin">Welcome to Segments!</h2>
            <p class="ion-no-margin segmentSubTitle">Create the segments of your customers using different set of filters and use it in CRM and Broadcast.</p>
            <VButton class="vvd-btn-primary" connotation="cta" appearance="filled" label="Create new segment" icon="arrow-right-line" icon-trailing @click="() => editMode = true"></VButton>
          </div>
        </div>
        <pagination v-if="allSegments.length > 0 && !isSearchSegment" class="pagination-wrapper" :totalCount="totalSegments" :currentPage="currentPaginationNumber" :pageSize="10" @change="(e) => fetchSegments({ pageNumber: e.page })" />
      </div>

      <!-- Delete confirmation dialog -->
      <VDialog
        :open="deleteSegmentMode"
        headline="Are you sure?"
        modal
        @close="() => { deleteSegmentMode = false; segmentIndexToEdit = -1; segmentToDeleteId = undefined; }"
      >
        <template #body>
          <p class="vtext-body">You want to delete this segment?</p>
        </template>
        <template #action-items>
          <VButton class="vvd-btn-cancel" appearance="filled" label="Cancel" @click="() => { deleteSegmentMode = false; segmentIndexToEdit = -1; segmentToDeleteId = undefined; }"></VButton>
          <VButton class="vvd-btn-primary" connotation="cta" appearance="filled" label="Yes" @click="deleteSegment"></VButton>
        </template>
      </VDialog>
    </div>

    <div v-else>
      <div class="edit-toolbar">
        <div class="toolbar-start">
          <VIcon @click="() => {editMode = false; segmentIndexToEdit = -1; }" :size="-4" name="arrow-left-line" class="cursorPointer" />
          <h2 class="condition-header">{{ segmentIndexToEdit > -1 ? 'Edit' : 'Create'}} segment</h2>
        </div>
        <VButton class="vvd-btn-primary custMarginRight" connotation="cta" appearance="filled" label="Save" @click="saveSegment"></VButton>
      </div>
      <div class="segments-edit-grid gridMargin">
        <div class="row-layout">
          <div class="col-main" :class="{ mobileSgement: showConditionActions }">
            <div class="segement-container marginBottom">
              <div>
                <h2 class="orderSubtitle"> Segment Name (Max 120 characters) </h2>
                <div class="counter-wrapper">
                  <VTextField v-model="editSegment.name" type="text" :maxlength="120" placeholder="Enter segment name" aria-label="Segment name" appearance="ghost" class="vivid-input"></VTextField>
                  <div class="custom-counter">
                      {{ (editSegment.name || '').length }}/120
                  </div>
                </div>
              </div>
            </div>
            <div class="segement-container">
              <div>
                <h2 class="orderSubtitle marginBottom"> Conditions </h2>
              </div>
              <div class="segment-settings">
                <div class="segment-settings-grid">
                  <div>
                    <CustomerSegments id="CustomerSegments" ref="CustomerSegments" :editSegment="editSegment" @clickedOnAddCondition="showActions"></CustomerSegments>
                  </div>
                  <div class="target-customers-section">
                    <SegmentsTargetingCount ref="SegmentsTargetingCount" @callFetchTargetedCustomerCount="callFetchTargetedCustomerCount"></SegmentsTargetingCount>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="showConditionActions" class="col-sidebar actions-column">
            <div class="conditions-container">
              <div class="itemPadding">
                <CustomerSegmentsActions :segmentQueryString="segmentQueryString" @close="showConditionActions = false" @actionClick="onActionClick" type="segments"></CustomerSegmentsActions>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <exports-modal-v2 v-if="csvExportWithDateRangeModal" :type="csvExportWithDateRangeModal_type" :isOpen="csvExportWithDateRangeModal" :title="csvExportWithDateRangeModal_title" :downloadID="downloadID" @close="() => csvExportWithDateRangeModal = false"></exports-modal-v2>
  </master-layout>
</template>

<script>
import ActionPopOver from "@/components/ActionPopOver.vue";
import CustomerSegmentsActions from "@/components/customer-segments/customer-segment-actions.vue";
import CustomerSegments from "@/components/customer-segments/customer-segments-v2.vue";
import SegmentsTargetingCount from "@/components/customer-segments/SegmentsTargetingCount.vue";
import pagination from "/src/components/pagination.vue";
import apiInterceptor from '@/shared/apiInterceptor';
import { parseTargetingConditions } from '@/helpers/segments.helpers';
import { useAuthStore } from '@/stores/auth';
import { useCsvExportModal } from '@/composables/useCsvExportModal';
import exportsModalV2 from '/src/components/exportModalV2.vue';
import { useUIStore } from '@/stores/ui';
import SearchBar from '@/components/SearchBar.vue';
import { environment } from '@/shared/env.js';
import { queryClient } from '@/shared/queryClient';

const EDIT_SEGMENT = {
  id: undefined,
  name: "Jumper Segment",
  targeting_conditions: [],
  targeting_count: 0
};

export default {
  components: {
    ActionPopOver,
    SearchBar,
    CustomerSegmentsActions,
    CustomerSegments,
    SegmentsTargetingCount,
    pagination,
    exportsModalV2
  },
  data() {
    return {
      allSegments: [],
      segmentsCache: {},
      segmentIndexToEdit: -1,
      segmentToDeleteId: undefined,
      segmentFilter: undefined,
      editMode: false,
      deleteSegmentMode: false,
      event: null,
      editSegment: { ...EDIT_SEGMENT },
      showConditionActions: false,
      segmentQueryString: "",
      currentPaginationNumber: 1,
      totalSegments: 0,
      isSearchSegment: false,
    };
  },
  setup() {
    const slctOptions = {
      cssClass: 'select-popover',
    };
    return { slctOptions, ...useCsvExportModal() }
  },
  mounted() {
    this.fetchSegments();
  },
  watch: {
    segmentIndexToEdit() {
      const segmentToEdit = this.allSegments[this.segmentIndexToEdit];
      if (this.segmentIndexToEdit > -1 && segmentToEdit) {
        this.editSegment = this.allSegments[this.segmentIndexToEdit];
      } else {
        this.editSegment = { id: undefined, name: "Jumper Segment" + this.allSegments.length, targeting_conditions: [], targeting_count: 0 }
      }
    },
    segmentFilter(val) {
      if (!val || !val.trim()) {
        // User cleared the search text — restore full list
        if (this.isSearchSegment) {
          this.isSearchSegment = false;
          this.fetchSegments();
        }
      }
    },
  },
  methods: {
    onClickCreateSagment() {
      setTimeout(() => this.editMode = true, 10);
    },
    showActions() {
      this.showConditionActions = true;
      this.segmentQueryString = this.$refs.CustomerSegments.getQueryStringFromConditionArray()?.trim();
    },
    onActionClick(option) {
      this.showConditionActions = false;
      this.$refs.CustomerSegments.addCondition(option);
    },
    callFetchTargetedCustomerCount() {
      const isValid = this.$refs.CustomerSegments.validateConditions();
      if (!isValid) {
        return;
      }

      const queryString = this.$refs.CustomerSegments.getQueryStringFromConditionArray()?.trim();
      if (queryString?.length) {
        this.$refs.SegmentsTargetingCount.fetchTargetedCustomerCountByQueryString(queryString, 'segments');
      } else {
        useUIStore().updateToast({ open: true, message: "Minimum one condition is required for segment.", type: "danger", });
      }
    },
    async fetchSegments(data) {
      try {
        useUIStore().updateLoading({ isLoading: true, message: 'Loading segments...' });
        if (data) {
          const { pageNumber } = data;
          this.currentPaginationNumber = pageNumber;
        }
        let offsetValue;
        if (this.currentPaginationNumber > 1) {
          offsetValue = (this.currentPaginationNumber - 1) * 10;
        }
        const params = {
          limit: 10,
          offset: offsetValue,
        };
        let allSegmentsResponse = await apiInterceptor.get( environment("VUE_APP_API_URL") + "crm/v1/segments/", { params } );
        this.allSegments = allSegmentsResponse.segments;
        this.totalSegments = allSegmentsResponse.total;
        // Build a name-keyed cache so search results (which lack IDs) can be enriched
        allSegmentsResponse.segments.forEach(s => { this.segmentsCache[s.name] = s; });
      } catch (error) {
        useUIStore().updateToast({ open: true, message: error.message, type: "danger", });
      } finally {
        useUIStore().updateLoading({ isLoading: false });
      }
    },
    async saveSegment() {
      try {

        const isValid = this.$refs.CustomerSegments.validateConditions();
        if (!isValid) {
          return;
        }

        const queryString = this.$refs.CustomerSegments.getQueryStringFromConditionArray()?.trim();

        // start Validation
        if (!this.editSegment?.name?.trim()) {
          useUIStore().updateToast({ open: true, message: "Please enter segment name.", type: "danger", });
          return;
        }
        if (!queryString) {
          useUIStore().updateToast({ open: true, message: "Minimum one condition is required for segment.", type: "danger", });
          return;
        }

        if (!queryString.includes("platform")) {
          useUIStore().updateToast({ open: true, message: "Please add 'Last Interaction => Interaction Channel' to the targeting condition!", type: "danger", });
          return;
        }
        // *** end validation ***
        useUIStore().updateLoading({ isLoading: true, message: 'Saving segment...' });
        let reqBody = {};
        if(this.validateName()) {
          reqBody['name'] = this.editSegment.name;
        } else {
          return
        }
        const updatedConditions = parseTargetingConditions(queryString, useAuthStore().authData?.userId);
        reqBody['targeting_conditions'] = updatedConditions;
        let message = '';
        if (this.editSegment.id) {
          await apiInterceptor.put(environment("VUE_APP_API_URL") + "crm/v1/segments/" + this.editSegment.id , reqBody)
          message = `"${this.editSegment.name}" segment updated successfully`;
        } else {
          await apiInterceptor.post(environment("VUE_APP_API_URL") + "crm/v1/segments/", reqBody);
          message = `"${this.editSegment.name}" segment created successfully`;
        }
        await queryClient.invalidateQueries({ queryKey: ['segments'] });
        this.editMode = false;
        this.segmentIndexToEdit = -1;
        useUIStore().updateLoading({ isLoading: false });
        useUIStore().updateToast({ open: true, message: message, type: "success" });
        this.fetchSegments();
      } catch (error) {
        useUIStore().updateToast({
          open: true,
          message: error.message,
          type: "danger"
        })
      } finally {
        useUIStore().updateLoading({ isLoading: false });
      }
    },
    async deleteSegment() {
      let errorMessage = '';
      useUIStore().updateLoading({ isLoading: true, message: 'Deleting segment...' });
      try {
        await apiInterceptor.delete( environment("VUE_APP_API_URL") + "crm/v1/segments/" + this.segmentToDeleteId );
        await queryClient.invalidateQueries({ queryKey: ['segments'] });
        useUIStore().updateToast({ open: true, message: "Segment is deleted successfully.", type: "success" });
        this.segmentFilter = '';
        this.isSearchSegment = false;
        await this.fetchSegments();
      } catch (error) {
        errorMessage = error.message;
      } finally {
        useUIStore().updateLoading({ isLoading: false });
        this.deleteSegmentMode = false;
        this.segmentIndexToEdit = -1;
        this.segmentToDeleteId = undefined;
        if (errorMessage) {
          useUIStore().updateToast({ open: true, message: errorMessage, type: "danger", });
        }
      }
    },
    async downloadSegmentCustomers_Csv(id) {
      try {
        this.csvExportWithDateRangeModal_open('Segments','Download segment customers', id);
      } catch (error) {
        useUIStore().updateToast({ open: true, message: error.message, type: "danger" });
      }
    },
    async searchSegments() {
      try {
        if(this.segmentFilter && this.segmentFilter.trim()) {
          useUIStore().updateLoading({ isLoading: true, message: 'Searching segments...' });
          this.currentPaginationNumber = 1;
          this.isSearchSegment = true;
          const params = {
            segment_name: this.segmentFilter.trim(),
          };
          let segmentResponse = await apiInterceptor.get( environment("VUE_APP_API_URL") + "crm/v1/segments/search/", { params } );
          // Handle "no results" response: API returns { success: false, data: {} }
          if (segmentResponse && segmentResponse.success === false) {
            this.allSegments = [];
            return;
          }
          // The search endpoint returns only {name, targeting_conditions} without IDs,
          // so enrich each result from our cache (populated by fetchSegments)
          let searchResults = [];
          if (Array.isArray(segmentResponse)) {
            searchResults = segmentResponse;
          } else if (segmentResponse && Array.isArray(segmentResponse.segments)) {
            searchResults = segmentResponse.segments;
          } else if (segmentResponse && Array.isArray(segmentResponse.data)) {
            searchResults = segmentResponse.data;
          }
          this.allSegments = searchResults.map(s => ({ ...this.segmentsCache[s.name], ...s }));
        } else {
          useUIStore().updateToast({
            open: true,
            message: "Please enter segment name",
            type: "warning"
          })
        }
      } catch (error) {
        // Search API may throw (e.g. 404) when no results found — show empty state
        if (this.isSearchSegment) {
          this.allSegments = [];
        }
      } finally {
        useUIStore().updateLoading({ isLoading: false });
      }
    },
    clearFilter() {
      this.segmentFilter = '';
      this.isSearchSegment = false;
      this.fetchSegments();
    },
    onEnterSearch() {
      this.searchSegments();
    },
    onBlurSearch() {
      if (this.segmentFilter && this.segmentFilter.trim() && !this.isSearchSegment) {
        this.searchSegments();
      }
    },
    validateName() {
      const name = this.editSegment.name.trim();
      const maxLength = 120;
      const allowedPattern = /^[a-zA-Z0-9 _]+$/; // Alphanumeric, space, underscore only

      if (!name) {
        useUIStore().updateToast({ open: true, message: 'Name cannot be empty.', type: "danger" });
        return false;
      }

      if (name.length > maxLength) {
        useUIStore().updateToast({ open: true, message: `Name must be at most ${maxLength} characters.`, type: "danger" });
        return false;
      }

      if (!allowedPattern.test(name)) {
        useUIStore().updateToast({ open: true, message: 'Name contains invalid characters.', type: "danger" });
        return false;
      }

      return true;
    }
  },
};
</script>

<style scoped>
#CustomerSegments {
  padding-bottom: 20px;
  border-bottom: 1px solid var(--background-primary);
}
.target-customers-section {
  padding-top: 20px;
}
.marginRight {
  margin-right: 20px;
}
.orderSubtitle {
  font-size: 14px;
  font-weight: 400;
  color: var(--gray-04);
  margin: 0 0 10px 0;
}

.segmentImg {
  max-width: 200px;
  width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
}
.segment-search-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  margin: 20px;
  gap: 16px;
}
.segment-search-field {
  width: 30%;
}
.search-btn {
  flex-shrink: 0;
}
.vivid-input {
  background: var(--white);
  border-radius: 25px;
  min-height: 40px;
  width: 100%;
}
.segement-container .vivid-input {
  background: var(--background-primary);
  border-radius: 5px;
}
.segment-list {
  background: var(--white);
  padding: 20px;
  border-bottom: 1px solid var(--background-primary);
  border-radius: 5px 5px 0px 0px;
}
.segment-info {
  border-radius: 0px 0px 5px 5px;
  background: var(--white);
  padding: 0 20px;
}

/* Table grid layout */
.segment-table-header,
.segment-table-row {
  display: grid;
  grid-template-columns: 6fr 6fr;
  align-items: center;
  gap: 10px;
}
.col-name { min-width: 0; }
.col-actions { min-width: 0; }
.col-mobile-actions { min-width: 0; }
.text-right { text-align: right; }

.actionFlexContainer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 20px;
}

.filterImg {
  max-width: 200px;
  width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
}
.segement-container {
  background: var(--white);
  border-radius: 5px;
  padding: 20px;
}
.conditions-container {
  background: var(--white);
  border-radius: 5px;
}
.condition-header {
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 21px;
  color: var(--black);
  margin: 0;
}
.itemPadding {
  border-bottom: 1px solid var(--background-primary);
  margin-bottom: 10px;
}

.rowBorder {
  border-bottom: 1px solid var(--background-primary);
  padding: 14px 0px;
}
.rowBorder:last-child {
  border-bottom: none;
}
.listContainer {
  display: flex;
  flex-direction: column;
  padding: 8px 0;
}
.popover-item {
  background: none;
  border: none;
  font: inherit;
  font-size: 14px;
  padding: 10px 16px;
  text-align: left;
  cursor: pointer;
  color: var(--black);
  transition: background 0.2s;
}
.popover-item:hover {
  background: var(--background-primary);
}
.popover-item--danger {
  color: var(--orange);
}
.emptySegments {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 130px auto;
}
.custMarginRight {
  margin-right: 10px;
}
.backBttn {
  color: var(--black);
}

/* Edit mode toolbar */
.edit-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  border-bottom: 1px solid var(--background-primary);
  background: var(--white);
}
.toolbar-start {
  display: flex;
  align-items: center;
  gap: 10px;
}

/* Edit mode layout */
.row-layout {
  display: flex;
  gap: 0;
}
.col-main {
  flex: 0 0 66.66%;
  max-width: 66.66%;
}
.col-sidebar {
  flex: 0 0 33.33%;
  max-width: 33.33%;
}
.actions-column {
  padding-left: 20px;
}
.pagination-wrapper {
  padding: 0px 20px 0px 0px;
}
.segmentContainer {
  height: calc(100dvh - 200px);
  overflow-y: auto;
}

/* Tooltips */
.tooltip_container {
  position: relative;
  display: inline-block;
}
.tooltip_container .tooltip_text {
  visibility: hidden;
  font-size: 13px;
  background-color: var(--black);
  color: var(--white);
  pointer-events: none;
  opacity: 0;
  transition: all 0.2s ease-out;
  text-align: center;
  padding: 5px;
  line-height: 1.5;
  border-radius: 5px;
  position: absolute;
  z-index: 1;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
}
.tooltip_container:hover .tooltip_text {
  visibility: visible;
  opacity: 1;
}
.tooltip_container .tooltip_text::after {
  content: " ";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: var(--black) transparent transparent transparent;
}

/* Responsive */
.desktop-only {
  display: block;
}
.mobile-only {
  display: none;
}
@media only screen and (max-width: 760px) {
  .desktop-only {
    display: none !important;
  }
  .mobile-only {
    display: block;
  }
  .segment-search-field {
    width: 100%;
  }
  .segment-table-header,
  .segment-table-row {
    grid-template-columns: 11fr 1fr;
  }
  .rowBorder {
    padding: 10px;
  }
}
@media only screen and (max-width: 991px) {
  .mobileSgement {
    display: none;
  }
  .custMarginRight {
    margin-right: 20px;
  }
  .actions-column {
    padding-left: 0px;
  }
  .segment-settings-grid {
    margin: 5px;
  }
  .row-layout {
    flex-direction: column;
  }
  .col-main,
  .col-sidebar {
    flex: none;
    max-width: 100%;
  }
}
</style>
